// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m5s1","index":"styles_index__dTqW4"};